import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import { Button } from '../Buttons/Button'
import './styles.css'

interface ConfirmModalProps {
  isOpen: boolean
  title?: string
  message: string
  onConfirm: () => void
  onClose: () => void
}

const ConfirmationModal: FC<ConfirmModalProps> = ({ isOpen, title, message, onConfirm, onClose }) => {
  const { t } = useTranslation()

  const footer = (
    <div className="modal-actions">
      <Button variant="primary" size="compact" style={{ flexGrow: 1 }} onClick={onConfirm}>
        {t('modal.confirm')}
      </Button>
      <Button variant="secondary" size="compact" style={{ flexGrow: 1 }} onClick={onClose}>
        {t('modal.cancel')}
      </Button>
    </div>
  )

  return (
    <BaseModal isOpen={isOpen} title={title || t('modal.defaultTitle')} onClose={onClose} footer={footer}>
      <p>{message}</p>
    </BaseModal>
  )
}

export default ConfirmationModal
